export default __webpack_public_path__ + "static/bootstrap-593aaeba13e91f7ef00e8b43bacf94de.png";